// @flow

import type { Color, PackageColor } from '../../../types/pdb';
import type { State } from '../types';
import { getPackages, getPackageIdFromUrl } from './packages';
import type { State as RouterState } from '../../router/types';

import {
  getPdbItem,
} from './main';

type GlobalState = {
  pdb: State,
  router: RouterState,
};

export const getColors = (state: GlobalState, pdbId: ?string = null): Array<Color> => {
  const pdbItem = getPdbItem(state, pdbId);
  return pdbItem.colors || [];
};

export const getColorById = (
  state: GlobalState,
  pdbId: ?string = null,
  colorId?: number = 0,
): ?Color => {
  const colors = getColors(state, pdbId);
  if (!colors) {
    return null;
  }

  const color = colors.find(c => c.id === colorId);
  if (!color) {
    throw Error('Couldn\'t find color by id');
  }

  return color;
};

export const getColorsByPackage = (
  state: GlobalState,
  pdbId: ?string = null,
  packageId: ?number = null,
): Array<PackageColor> => {
  const pkgId = packageId || getPackageIdFromUrl(state);
  if (pkgId === null) {
    return [];
  }

  const packages = getPackages(state, pdbId);
  const activePackage = packages.find(pack => (pack.id === pkgId));

  if (activePackage) {
    return (activePackage.mapped && activePackage.mapped.colors) || [];
  }
  return [];
};

export const getDefaultColor = (
  state: GlobalState,
  pdbId: ?string = null,
  packageId: ?number = null,
): ?Color => {
  const goal = 0;
  const pkgId = packageId || getPackageIdFromUrl(state);
  const colors = getColorsByPackage(state, pdbId, pkgId);

  if (!colors || colors.length === 0) {
    return null;
  }

  if (colors.length === 1) {
    return colors[0];
  }

  const closest = colors.reduce((prev, curr) => {
    const currPrice = Math.abs(parseInt(curr.price, 10) - goal);
    const prevPrice = Math.abs(parseInt(prev.price, 10) - goal);
    return (currPrice < prevPrice ? curr : prev);
  });
  return closest;
};

export const getFirstColorName = (state: GlobalState): ?string => {
  const colors = getColors(state);
  return colors[0] ? colors[0].name : null;
};

export default null;
